// extracted by mini-css-extract-plugin
export default {"mainContainer":"Home_mainContainer__LvVPn","spinnerContainer":"Home_spinnerContainer__-yXob"};